import { AssistantValue } from "../../../services/api/instances/assistantsApi/types";

export const getUpdatedValue = (
  value: AssistantValue,
  fields: Partial<AssistantValue["assistant_object"]> = {},
  meta?: Partial<AssistantValue["meta"]>
): AssistantValue => ({
  assistant_object: {
    ...value.assistant_object,
    ...fields,
  },
  ...(value.meta !== undefined || meta !== undefined
    ? { meta: { ...value.meta, ...meta } }
    : {}),
});
